export const MSGS = {
  MISSING_SESSION_SUCCESS: "Missing Session added successfully",
  SPLIT_SESSION_SUCCESS: "Activity updated successfully",
  ACTIVITY_AND_TASKS_SUCCESS: "Activities and tasks updated successfully.",
  ACTIVITY_STATUS_CHANGE: "Please note changing the activity status of the shift will automatically change the  status of the meal period and tasks occurring within this shift. Are you sure you want to continue ?",
  MANAGE_ACTIVITIES:  "You have valid activities within this shift. Please manage your meal periods and tasks."
};

export default MSGS;
